export default __webpack_public_path__ + "static/media/dieppe6.1e8d7e5a.jpg";